export type SessionStatus = 'cloning' | 'setting-up' | 'running' | 'complete' | 'failed'

export interface SessionScore {
  passed: boolean
  durationMs: number
  promptCount: number
}

export interface SessionEnv {
  nodeVersion: string
  platform: string
  shell?: string
  packageManager?: string
}

export interface Session {
  id: string
  scenarioName: string
  workdir: string
  systemPromptPath: string
  status: SessionStatus
  createdAt: string
  startedAt?: string
  completedAt?: string
  provider?: string
  compromised?: boolean
  score?: SessionScore
  env?: SessionEnv
  setupLog?: string
  changesDiff?: string
  verifyOutput?: string
  exitCode?: number
}

export type StoredSession = Session

export function toStoredSession(session: Session): StoredSession {
  return { ...session }
}
